import React from 'react';
import * as Recharts from 'recharts';
import { useWindowResize } from '../../../../helpers/hooks';
import ChartTooptip from '../ChartTooltip';
import ChartLabel from '../ChartLabel';

const HorizontalChart = ({
  data,
  yAxisDatakey,
  xAxisDatakey,
  barColor,
}) => {
  const [width] = useWindowResize();
  const isMobile = width > 0 && width <= 768;
  const axisPad = isMobile ? 110 : 250;

  return (
    <Recharts.ResponsiveContainer height={isMobile ? 280 : 350} width="100%">
      <Recharts.ComposedChart data={data} margin={{ top: 0, left: 0, right: isMobile ? 36 : 50 }} layout="vertical">
        <Recharts.XAxis
          type="number"
          padding={{ left: axisPad }}
          hide
        />
        <Recharts.YAxis
          axisLine={false}
          dataKey={yAxisDatakey}
          mirror
          tick={{
            fontSize: '12px',
            fill: '#B7B8BA',
            fontWeight: 500,
            fontFamily: 'Roboto',
          }}
          tickFormatter={isMobile ? (v) => (String(v).length > 12 ? `${String(v).slice(0, 11)}…` : String(v)) : undefined}
          width={isMobile ? 100 : 225}
          type="category"
          padding={{ left: 0, right: axisPad }}
          tickLine={false}
        />
        <Recharts.Tooltip
          content={<ChartTooptip isPercentage />}
          labelStyle={{ color: '#283238', fontSize: '14px', lineHeight: '27px' }}
          cursor={null}
        />
        <Recharts.Bar
          dataKey={xAxisDatakey}
          fill={barColor}
          layout="vertical"
          radius={[10, 10, 10, 10]}
          barSize={isMobile ? 18 : 25}
        >
          <Recharts.LabelList dataKey="percentage" position="right" content={ChartLabel} />
        </Recharts.Bar>
      </Recharts.ComposedChart>
    </Recharts.ResponsiveContainer>
  );
};


export default HorizontalChart;
